
import { useEffect, useState } from 'react';

interface AboutProps {
  scrollY: number;
}

export default function About({ scrollY }: AboutProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('about');
      if (element) {
        const rect = element.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight * 0.7);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-stone-100 to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            <h2 className="text-5xl md:text-6xl font-bold mb-8 bg-gradient-to-r from-amber-800 to-red-700 bg-clip-text text-transparent">
              About Sacred Frequency
            </h2>
            <div className="space-y-6 text-lg text-stone-700 leading-relaxed">
              <p>
                Sacred Frequency was born from the rhythm of the soul — where ritual meets restoration 
                and self-care becomes ceremony.
              </p>
              <p>
                Every blend, oil, and candle is crafted with divine intention — guided by ancient herbal 
                wisdom and infused with the energy of love, protection, and elevation.
              </p>
              <p>
                We believe your body is a temple, your mind a vessel, and your spirit a vibration that 
                deserves harmony. Each product carries its own frequency — designed to help you return 
                home to your highest self.
              </p>
              <p className="text-xl font-medium text-amber-800 italic">
                Sip. Soak. Breathe. Align.
              </p>
              <p className="text-xl font-semibold text-stone-800">
                Welcome to Sacred Frequency — where luxury meets lightwork.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-leaf-line text-green-600 text-xl"></i>
                </div>
                <span className="text-stone-600 font-medium">100% Natural Ingredients</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-heart-line text-red-600 text-xl"></i>
                </div>
                <span className="text-stone-600 font-medium">Ethically Sourced</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-star-line text-amber-600 text-xl"></i>
                </div>
                <span className="text-stone-600 font-medium">Handcrafted with Intention</span>
              </div>
            </div>
          </div>
          
          <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/cbf2daa191017225ab9ddec7b2c4900e/8b867444f37b0145c3fbdae8dab323f8.jpeg"
                alt="Sacred Frequency founder"
                className="w-full h-[500px] object-cover object-center rounded-2xl shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
